var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('two-row-header'),_vm._v(" "),_c('main',{attrs:{"id":"main","role":"main","aria-hidden":_vm.ariaHiddenMain}},[_c('nuxt',{attrs:{"keep-alive-props":{ max: 10, exclude: ['ResourceList', 'CommentList'] }}})],1),_vm._v(" "),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }